// 文字省略
$().ready(function () {

});

// 空室一覧 検索結果一覧・ブランド検索結果一覧・ランキング結果一覧・新築マンション一覧
$(function () {
    $('.list          #roomList .archive,' +
        '.ranking       #roomList .archive,' +
        '#new-building  #roomList .archive').click(function (e) {
            var $moreLabel = $(this).find('p#more');
            var rooms = $moreLabel.text().match(/\d+件/);

            if ($(this).attr("class") == "archive more") {
                $(this).closest("#roomList").find(".roomContainer").toggleClass("show");
                $(this).toggleClass("more_on");
                $moreLabel.text('その他' + rooms + 'を非表示');
            } else {
                $(this).closest("#roomList").find(".roomContainer").toggleClass("show");
                $(this).toggleClass("more_on");
                $moreLabel.text('その他' + rooms + 'を表示');
            }
        });
});

// 空室一覧 建物詳細／部屋詳細
$(function () {
    $('.building #roomList .archive , .room #roomList .archive').click(function (e) {
        var $moreLabel = $(this).find('p#more');
        var rooms = $moreLabel.text().match(/\d+件/);

        if (!$(this).hasClass('more_on')) {
            $(this).closest("#estate_room_list").find(".roomList-inner").toggleClass("show");
            $(this).toggleClass("more_on");
            $moreLabel.text('その他' + rooms + 'を非表示');
        } else {
            $(this).closest("#estate_room_list").find(".roomList-inner").toggleClass("show");
            $(this).toggleClass("more_on");
            $moreLabel.text('その他' + rooms + 'を表示');
        }
    });
});

// 検討中リストをクリックした時にCookie関連の処理を追加したもの。
// 松本さんが作ってくれたものとかぶる可能性があるので気をつける。
$(function () {
    $("#js-roomDetail .review, .chart_review .review").on("click", function () {
        if ($(this).hasClass("review_ed")) {
            $(this).removeClass("review_ed");
            removeFromConsiderList($(this));
        } else {
            $(this).addClass("review_ed");
            addToConsiderList($(this));
        }
    });
});

// ページ中部 検討中リストに追加する／追加済みボタン
$(function () {
    $(document).on("click", ".bldg-contact .toReview", function (event) {
        addToConsiderList($(this));
        $('.bldg-contact .toReview').removeClass("toReview").addClass("toReview_ed");
        $('.room #navigationL .toReview').removeClass("toReview").addClass("toReview_ed");
        $(".bldg-contact .add-review-btn").text('検討中リスト追加済');
    });

    $(document).on("click", ".bldg-contact .toReview_ed", function (event) {
        removeFromConsiderList($(this));
        $('.bldg-contact .toReview_ed').removeClass("toReview_ed").addClass("toReview");
        $('.room #navigationL .toReview_ed').removeClass("toReview_ed").addClass("toReview");
        $(".bldg-contact .add-review-btn").text('検討中リスト追加');
    });
});

// 前のページへ戻るボタンを押したらブラウザバック
$(function () {
    $("#toList .back-btn").on('click', function () {
        history.back();
        return false;
    });
});

$(function () {
    if ($("#gMap").length == 0) {
        return;
    }

    /*
    @param   latleng   google.maps.LatLng
    @return  void
    */
    var showMaps = function (latlng) {
        // 地図のオプション設定
        var mapOptions = {
            zoom: 16, /*初期のズーム レベル */
            center: latlng, /* 地図の中心地点 */
            mapTypeId: google.maps.MapTypeId.ROADMAP, /* 地図タイプ */
            streetViewControl: false, /* ストリートビュー コントロール */
        };
        // 地図表示
        var map = new google.maps.Map(document.getElementById('gMap'), mapOptions);

        // 地図のマーカーオブジェクト
        var marker = new google.maps.Marker({
            position: latlng, /* マーカーを立てる場所の緯度・経度 */
            map: map /*マーカーを配置する地図オブジェクト */
        });

    }

    // 地図の表記削除
    var removeMap = function () {
        // 地図要素の削除
        $('#maps').remove();
        // 地図へのリンク削除
        var $mapLink = $('#toBtn .toPageLink a[href="#maps"]'),
            $mapLinkWrap = $mapLink.parent();
        // リンク要素の削除
        $mapLink.remove();
        // リンクボタンに変更
        $mapLinkWrap.addClass('toBtnNone').text('地図')
    }

    // 緯度経度の取得
    // 緯度 (latitude)  :  -90.000000 〜  90.000000
    // 経度 (longitude) : -180.000000 〜 180.000000
    var lat = $('#mapLatitude').val(), lng = $('#mapLongitude').val();
    if (lat == "0" && lng == "0") {
        // 緯度経度が取得されていない場合は、地図を表示しない。
        removeMap();
    } else if (lat && lng) {
        // 緯度経度が取得されている場合は、地図を表示
        showMaps(new google.maps.LatLng(lat, lng));
    } else {
        // 緯度経度が登録されていない場合のジオコーディング
        var geocoder = new google.maps.Geocoder();

        // 緯度経度取得(非同期)
        var getGeocode = function (address) {
            var $def = new $.Deferred();
            geocoder.geocode({ 'address': address, 'region': 'jp' },
                function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        var result = null
                        // 町域チェック
                        for (var i = 0; i < results.length; i++) {
                            var prefecture = "", city = "", town = "";
                            for (var j = results[i].address_components.length - 1; j >= 0; j--) {
                                // 都道府県取得
                                if (results[i].address_components[j].types.indexOf("administrative_area_level_1") !== -1
                                    && results[i].address_components[j].types.indexOf("political") !== -1) {
                                    prefecture = results[i].address_components[j].long_name;
                                }
                                // 市区町村取得
                                if (results[i].address_components[j].types.indexOf("locality") !== -1
                                    && results[i].address_components[j].types.indexOf("political") !== -1) {
                                    city = results[i].address_components[j].long_name;
                                }
                                // 町域取得
                                if (results[i].address_components[j].types.indexOf("sublocality") !== -1
                                    && results[i].address_components[j].types.indexOf("sublocality_level_1") !== -1) {
                                    town = results[i].address_components[j].long_name;
                                }
                            }
                            // 都道府県／市区町村／町域チェック
                            if ($("#mapAddressPrefecture").val() == prefecture
                                && $("#mapAddressCity").val() == city
                                && $("#mapAddressTown").val() == town
                            ) {
                                // 結果が1つ目(未設定)の場合は、無条件で設定
                                if (result == null) {
                                    result = results[i];
                                } else {
                                    // 2つ目以降の場合は、address_componentsの数が多い方を取得
                                    if (results[i].address_components.length > result.address_components.length) {
                                        result = results[i];
                                    }
                                }
                            }
                        }

                        // 検索結果が取得されていたら、成功
                        if (result !== null) {
                            return $def.resolve({ result: result, status: status });
                        }
                    }
                    // 検索結果が取得されなかったら、失敗
                    return $def.reject({ status: status });
                }
            );
            return $def.promise();
        }

        getGeocode($('#mapAddress').val())
            .pipe( // jQuery 1.7の場合はpipe、jQuery 1.8以上の場合はthenに書き換えること
                false, // 結果取得は↓で
                function (data) {
                    // 1回目の位置情報取得失敗時は、住所の最後尾(号)を削って再検索
                    var sublocal = $('#mapAddress').val().split('-');
                    sublocal.pop();

                    // 住所取得
                    var address = sublocal.join('-')
                        ;
                    // 2回目の検索
                    return getGeocode(address);
                })
            .pipe( // jQuery 1.7の場合はpipe、jQuery 1.8以上の場合はthenに書き換えること
                function (data) {
                    // 成功時
                    showMaps(data.result.geometry.location);
                },
                function (data) {
                    // 2回目の位置情報取得失敗の場合は、地図を表示しない
                    removeMap();
                }
            )
            ;
    }
});

// 選択した住戸をまとめてお問い合わせ
$(function () {
    $('#footerFixed .allcheck .inq_room').on('click', function () {
        var $checked_rooms = $("[name='room_id[]']:checked");
        if ($checked_rooms.length > 0) {
            $checked_rooms.get(0).form.submit();
            return false;
        }
        alert('お問い合わせをする物件を選択してください');
    });
});

// 間取り図を拡大
$(document).ready(function () {
    if ($("a[rel='planimg1']:not([href*=no-image])").length != 0) {
        $("a[rel='planimg1']").colorbox();
    } else {
        $("a[rel='planimg1']").on("click", function () { return false; });
    }
    if ($("a[rel='planimg2']").length != 0) {
        $("a[rel='planimg2']").colorbox();
    }
});
$(function () {

    //data-hrefの属性を持つtrを選択しclassにclickableを付加
    $('tr[data-href]').addClass('clickable')

        //クリックイベント
        .click(function (e) {

            //e.targetはクリックした要素自体、それがa要素以外であれば
            var targetClass = $(e.target).closest("td").attr("class");
            switch (targetClass) {
                case "tower":
                case "floor":
                case "plan":
                case "size":
                case "price":
                case "rent":
                case "unit_price":
                case "unit_rent":
                case "manage":
                case "deposit":
                case "key_money":
                case "brokerage":
                case "yield":
                case "occupancy":
                case "freerent":
                case "detail":

                    // ページ遷移前にhover解除、ビューア非表示
                    $(this).removeClass("hover");
                    $(".floor_plan_view").hide()
                        .find("img").attr("src", "")
                        ;

                    //その要素の先祖要素で一番近いtrの
                    //data-href属性の値に書かれているURLに遷移する
                    window.location = $(e.target).closest('tr').data('href');
            }
        });
});

// 閲覧済み部屋登録
function addViewedRooms(roomId) {
    var viewedRooms = $("input[name=viewed_rooms]").val().split(",");
    viewedRooms = $.grep(viewedRooms, function (e) { return e; });
    if ($.inArray(roomId, viewedRooms) === -1) {
        viewedRooms.push(roomId);
    }
    $("input[name=viewed_rooms]").val(viewedRooms.join(","));
}

// 閲覧済み部屋設定
$(function () {
    if ($("input[name=viewed_rooms]").length === 0) return;
    var viewedRooms = $("input[name=viewed_rooms]").val().split(",");
    viewedRooms = $.grep(viewedRooms, function (e) { return e; });
    var table = $(".roomList, #soldoutList").find("table");
    for (var i = 0; i < viewedRooms.length; i++) {
        table.find("tr[data-room_id=" + viewedRooms[i] + "]").addClass("viewed");
    }
})

// 部屋一覧ソート
$(function () {

    // イベントハンドラがない場合、処理しない
    if (window.roomSortableHeader_clickHandler == null) return;

    // ヘッダークリックに部屋ソート処理を追加
    $(".roomList table").find("th[data-sort]").on("click", roomSortableHeader_clickHandler);

    // ブラウザバック時の部屋ソート同期処理
    var roomSortSyncAll = function () {
        $(".roomList table").each(function () {
            roomSortSync(this);
        });
    }

    if (window.onpageshow != null) {
        // pageshowイベントがある場合は、pageshowにて部屋ソート同期処理を実行
        $(window).on("pageshow", function () {
            roomSortSyncAll();
        });
    } else {
        // pageshowイベントがない場合は、ready内にて部屋ソート同期処理を実行
        roomSortSyncAll();
    }

});

// 間取り画像表示
$(function () {
    // スマホ、タブレットの場合は無効
    var ua = navigator.userAgent;
    if (ua.indexOf('iPhone') > -1 || (ua.indexOf('Android') > -1 && ua.indexOf('Mobile') > -1)) {
        // スマートフォン
        var is_pc = false;
    } else if (ua.indexOf('iPad') > -1 || ua.indexOf('Android') > -1) {
        // タブレット
        var is_pc = false;
    } else {
        // PC
        var is_pc = true;
    }
    if (is_pc) {
        view_room_image();
    }
    function view_room_image() {
        // ビューア作成
        var floorPlanView = $("<figure></figure>", {
            "id": "fixedRoomMap",
            "class": "room-map-wrap"
        }).append($("<img>", {
            "class": "room-map",
            alt: "間取り画像"
        })).hide();
        floorPlanView.appendTo(".room-table");

        // 画像読込完了時にビューア表示
        $(".room-map-wrap img").on("load", function () {
            $(this).closest(".room-map-wrap").show();
        });

        // 検索結果一覧ページの処理
        $(".room-table-tr td").on({
            "mouseenter": function () {
                // 検討中、問合せ、詳細の領域は無効
                if ($(this).hasClass("occupancy") || $(this).hasClass("chart_review")
                    || $(this).hasClass("inq") || $(this).hasClass("check") || $(this).hasClass("detail")) {
                    return;
                }
                if (!$(this).closest("tr").data("photo_file1")) {
                    return;
                }
                var idx = $(".room-table-tr").index($(this).closest("tr")) + 1; // テーブルの上から何行目か
                var height = $(this).closest("tr").height(); // trの高さ
                // ビューア位置、画像設定（表示はloadイベントで実施）
                $(".room-map-wrap")
                    // 表示位置 trの行数 * trの高さ - 間取り画像表示位置調整分(55px)
                    .css("top", idx * height - 55 + "px")
                    .find("img").attr("src", $(this).closest("tr").data("photo_file1"))
                    ;
            },
            "mouseleave": function () {
                // ビューア非表示
                $(".room-map-wrap").hide()
                    .find("img").attr("src", "")
                    ;
            }
        });

        // 建物詳細・部屋詳細ページの処理
        $(".roomContainer .vacancy").on({
            "mouseenter": function () {
                if (!$(this).data("photo_file1")) {
                    alert("false");
                    return;
                }
                $(".floor_plan_view")
                    .find(".inner")
                    .css("top", $(this).get(0).getBoundingClientRect().top + window.pageYOffset - 260 + "px")
                    .css("left", $(this).get(0).getBoundingClientRect().left + "px")
                    .find("img").attr("src", $(this).data("photo_file1"))
                    ;
            },
            "mouseleave": function () {
                // ビューア非表示
                $(".floor_plan_view").hide()
                    .find("img").attr("src", "")
                    ;
            }
        });
    }
});

$(function () {
    // THETAビューアスクリプト
    var s = '<script class="theta_widgets" async src="https://theta360.com/widgets.js" charset="utf-8">';

    // THETAビューア閉じる
    function p360Close() {
        $("#p360_close").addClass("closed").text("open");

        // THETAビューア閉じる
        $("#p360_view").addClass("minimized").empty();
    }

    // THETAビューア開く
    function p360Open() {
        $("#p360_close").removeClass("closed").text("close");

        // ビューア対象サムネイル
        var curThumb;
        if (this.tagName.toLowerCase() !== "li") {
            curThumb = $("#p360_thumbnail li.selected")
        } else {
            curThumb = $(this);
            $("#p360_thumbnail li.selected").removeClass('selected');
            curThumb.addClass('selected');
        }

        // THETAビューア切替
        $("#p360_view").empty().removeClass("minimized").append(curThumb.data("photo360_code"));
        $("#p360_description").text(curThumb.find("p").text());

        // THETAビューアを再表示
        $(document).on("load", ".ricoh-theta-spherical-image", function () { $(".ricoh-theta-spherical-image").show(); });
        $(".theta_widgets").remove();
        $("body").append($(s));
    }

    // サムネイルクリック
    $(document).on("click", "#p360_thumbnail li:not(.selected)", p360Open);

    // THETAビューア閉じるボタン
    $("#p360_close").on("click", function () {
        if ($(this).hasClass("closed")) {
            p360Open.call(this);
        } else {
            p360Close.call(this);
        }
    })

    // THETAビューア初期表示
    var p360OpenFirst = function () {
        $("#p360_thumbnail li.selected").removeClass('selected');
        $("#p360_thumbnail li").eq(0).trigger("click");
    }
    if (window.onpageshow != null) {
        // pageshowイベントがある場合は、pageshowにてTHETAビューア初期表示を実行
        $(window).on("pageshow", function () {
            setTimeout(p360OpenFirst, 500);
        });
    } else {
        // pageshowイベントがない場合は、ready内にてTHETAビューア初期表示を実行
        setTimeout(p360OpenFirst, 500);
    }

    // 最近見た物件画像遅延読込
    $('#bldgConditions img.lazy').lazyload({
        effect: 'fadeIn',
        effectspeed: 500,
        threshold: 300,
    });

    // 空室一覧の物件画像遅延読込
    $(function () {
        if (typeof jQuery.fn.lazyload == 'function') {
            $('#roomList .roomContainer img.lazy').lazyload({
                effect: 'fadeIn',
                effectspeed: 500,
                threshold: 500,
                event: 'imageLazyLoad',
            });
        } else {
            $('#roomList .roomContainer img.lazy').map(function () {
                $(this).attr('src', $(this).data('original'));
            });
        }
    });
    $(function () {
        var timer = null;
        $(window).on('scroll', function () {
            clearTimeout(timer);
            timer = setTimeout(function () {
                var imgPos = $('#roomList .roomContainer').offset().top;
                var scroll = $(window).scrollTop();
                var windowHeight = $(window).height();
                if (scroll > imgPos - windowHeight + windowHeight / 5 - 500) {
                    $('#roomList .roomContainer img.lazy').trigger('imageLazyLoad');
                }
            }, 200);
        });
    });

});
